import React from "react";
import { Link } from "react-router-dom";
import ProductImage from "./ProductImage";
import { eur } from "../lib/format";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  return (
    <div className="group bg-white border border-border rounded-2xl overflow-hidden flex flex-col hover:border-brand/50 hover:shadow-lg transition-all" data-testid={`product-card-${product.slug}`}>
      <Link to={`/producto/${product.slug}`} className="block aspect-square bg-secondary overflow-hidden">
        <ProductImage
          src={product.images && product.images[0]}
          alt={product.name}
          className="w-full h-full object-contain p-3 group-hover:scale-105 transition-transform duration-300"
        />
      </Link>
      <div className="p-3 flex flex-col flex-1">
        {product.reference && (
          <span className="text-[10px] font-mono text-muted-foreground">REF {product.reference}</span>
        )}
        <Link to={`/producto/${product.slug}`} className="font-medium text-sm leading-snug mt-1 line-clamp-2 hover:text-brand transition-colors">
          {product.name}
        </Link>
        <div className="mt-auto pt-3 flex items-center justify-between">
          <span className="font-heading font-bold text-lg text-brand-ink">{eur(product.price)}{Number(product.min_qty) > 1 && <span className="block text-[10px] font-sans font-medium text-amber-700" data-testid={`min-qty-badge-${product.slug}`}>Mín. {product.min_qty} uds.</span>}</span>
          <button
            data-testid={`quick-add-${product.slug}`}
            onClick={() => {
              addItem(product);
              const mq = Number(product.min_qty) || 1;
              toast.success(mq > 1 ? `Añadido al pedido (mínimo ${mq} uds.)` : "Añadido al pedido");
            }}
            className="inline-flex items-center gap-1 bg-brand hover:bg-brand-dark text-white text-xs font-semibold px-3 py-2 rounded-full transition-colors"
          >
            <Plus className="h-3.5 w-3.5" /> Añadir
          </button>
        </div>
      </div>
    </div>
  );
}
